import { render, staticRenderFns } from "./Slide7.vue?vue&type=template&id=37346b5c&scoped=true&"
import script from "./Slide7.vue?vue&type=script&lang=js&"
export * from "./Slide7.vue?vue&type=script&lang=js&"
import style0 from "./Slide7.vue?vue&type=style&index=0&id=37346b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37346b5c",
  null
  
)

export default component.exports